import { render } from "./intermediary-list.vue?vue&type=template&id=2c46ef4f&lang=html"
import script from "./intermediary-list.vue?vue&type=script&lang=js"
export * from "./intermediary-list.vue?vue&type=script&lang=js"

import "./intermediary-list.vue?vue&type=style&index=0&id=2c46ef4f&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__